export default __webpack_public_path__ + "static/media/Ballroll_00058.d60df418.png";